


























import Vue from "vue";
import shopOrdercall from '../../../../shop.ordecall'
import select from '../../../../components/selectcopy'

export default Vue.extend({
	props: ['order'],
	data() {
		return {
			shopOrdercall: shopOrdercall,
		}
	},
    directives: {
        select
    }
})



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/webpack/vue/backend/components/table/fields/ContactsField.vue